import {
	useContext,
	useState,
	useEffect
} from 'react';
import { FeatureFlagContext } from '@components/CORE/FeatureFlag';
import { resolveFlag } from '@components/CORE/FeatureFlag/Utils';
import { FeatureFlag, FeatureFlagResolver } from '@types';

type TFeatureFlag<TMeta extends undefined | boolean> = TMeta extends undefined ? boolean : TMeta extends false ? boolean : [boolean, ({ [key:string]: any } | null)];

export const useFeatureFlag = <TMeta extends undefined | boolean>(name: string, test?: FeatureFlagResolver, withMeta?: TMeta):TFeatureFlag<TMeta> | boolean => {
	const flags = useContext<FeatureFlag[]>(FeatureFlagContext);
	const flag:FeatureFlag | undefined = flags.find((flag) => flag.name === name);
	const isOn:boolean = resolveFlag(flag?.on ?? false, test);
	const [flagActive, setFlagActive] = useState<boolean>(isOn);

	useEffect(() => {
		setFlagActive(isOn);
	}, [isOn]);

	if (withMeta !== undefined && withMeta) return [flagActive, flag?.meta ?? null] as TFeatureFlag<typeof withMeta>;
	return flagActive
}
